var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 180.823 221.5 L 316.232 221.5 L 312.594 178 L 420.823 250 L 312.594 322 L 316.232 278.5 L 180.823 278.5 L 180.823 221.5 Z",
    style: {
      fillRule: "nonzero",
      paintOrder: "stroke"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 409.434 169.742 C 409.434 175.265 404.955 179.742 399.43 179.742 L 374.774 179.708 C 372.306 179.708 364.087 180.833 364.67 169.708 L 364.764 109.011 L 139.966 108.664 C 134.723 108.664 130.422 112.701 130 117.836 L 130 390 C 130 395.523 134.477 400 140 400 L 364.782 399.653 L 364.67 327.434 C 364.087 316.312 372.306 317.436 374.774 317.436 L 399.43 317.402 C 404.955 317.402 409.434 321.878 409.434 327.4 L 409.434 420.902 L 409.415 420.902 L 409.434 434.346 C 409.434 439.869 404.957 444.346 399.434 444.346 L 99.434 444.346 C 93.911 444.346 89.434 439.869 89.434 434.346 L 89.434 168.8 L 89.4 168.8 L 89.4 74.304 C 89.4 68.779 93.877 64.3 99.4 64.3 L 399.4 64.3 C 402.646 64.3 405.53 65.847 407.357 68.244 C 408.659 69.932 409.434 72.049 409.434 74.346 L 409.43 76.219 L 409.434 76.219 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout3);
export default __webpack_public_path__ + "static/media/logout3.c9b7210a60e205f2236d27847f963486.svg";
export { ForwardRef as ReactComponent };